import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpRequest, HttpHandler, HttpResponse } from '@angular/common/http';
import { Observable, throwError, } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { LoaderService } from 'src/app/services/loader.service';

@Injectable()
export class HTTPInterceptor implements HttpInterceptor {
  private loaderControllers = [];
  constructor(public router: Router, private loaderService: LoaderService) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    //    if(this.loaderControllers.length==0){
    const loader = this.loaderService.showLoading();
    this.loaderControllers.push(loader);
    //    } 

    console.log("start")
    return next.handle(req).pipe(

      catchError(error => {
        console.log("stop")
        console.error("error is intercept", error);
        return throwError(error.message);
      }),
      finalize(() => {

        console.log("stop")
        this.loaderService.dismissAllLoaders()
      }),
    );
  }


}














